<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Consumable/Inventory'">
          <el-button type="primary" size="mini">易耗品盘点登记</el-button>
        </router-link>
      </div>

      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

    </div>

    <!-- <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="0">申请中/未出库材料</el-radio-button>
        <el-radio-button label="1">已出库材料</el-radio-button>
      </el-radio-group>
    </div> -->

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="盘点登记时间" prop="time"></el-table-column>
      <el-table-column label="盘点登记员">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="详情" width="80">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="ShowMaterialInventory(scope.row)" type="primary">查看</el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

    <!-- <consumable-back v-on:getList="getLists()" v-on:hideMaterialInventory="hideMaterialInventory()" :houseId="form.houseId"
      :consumableInventoryStatus="consumableInventoryStatus" :consumableInventoryInData="consumableInventoryInData"></consumable-back> -->

    <inventory-detail v-if="consumableInventoryDetailStatus"
      :consumableInventoryDetailStatus="consumableInventoryDetailStatus" :form="consumableInventoryDetailInData"
      v-on:hideMaterialInventoryDetail="hideMaterialInventoryDetail()"></inventory-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'

  import InventoryDetail from '@/page/consumable/components/inventoryDetail'
  export default {
    components: {
      UserInfo,
      projectInfo,

      // MaterialInventory,
      InventoryDetail,
    },
    mixins: [approvalType, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        // 盘点详情单明细详情
        consumableInventoryDetailStatus: false,
        consumableInventoryDetailInData: "",
        // 是否可切换公司
        noSelectOrganization: false,
        houseList: "",

        organizationListData: [],
        addMeetingRoomStatus: false,

        form: {
          depId: '',
          type: 0
        },
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        // filter
        filterKey: "",
      }
    },
    created() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.depId == "7") {
        this.noSelectOrganization = false
      }
    },
    mounted() {},
    methods: {
      // 隐藏盘点详情
      hideMaterialInventoryDetail() {
        this.consumableInventoryDetailStatus = false
      },
      // 显示盘点详情弹窗
      ShowMaterialInventory(row) {
        ajax.get('/consumable/pan/info/' + row.id, '', (res) => {
          this.consumableInventoryDetailStatus = true
          this.consumableInventoryDetailInData = res.vo
          console.log(this.consumableInventoryDetailInData)
        })
      },
      getDateByTime(time) {
        return window.util.getFormatDate(time, true)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        // console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _item.projectName
              .toLowerCase()
              .indexOf(this.filterKey.toLowerCase()) != -1 || _item.customer.toLowerCase().indexOf(this.filterKey
                .toLowerCase()) !=
              -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.filterKey = ""
        this.loading = true
        let _url = '/consumable/pan/list'

        ajax.get(_url, this.form, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'form.depId'() {
        this.getLists()
      },
      'form.type'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/InventoryList.vue